import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const paydayApi = axios.create({
  baseURL: API_BASE_URL + "api/payday",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
